import React, { useState, useEffect } from "react";
import { getAuth, updateProfile } from "firebase/auth";
import { FcHome } from "react-icons/fc";
import AdsList from "../components/AdsList.jsx";
import { variables } from '../Variables.jsx';
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { db } from "../firebase";
import { doc, updateDoc } from "firebase/firestore";
import { useTranslation } from "react-i18next";
 import  BiensList  from "../components/BiensList.jsx"

function MyAds() {
  const auth = getAuth();
  const navigate = useNavigate();
  const [changeDetail, setChangeDetail] = useState(false);
  const [biens, setBiens] = useState([]);
  const [name, setName] = useState(auth.currentUser.displayName);
  const [email, setEmail] = useState(auth.currentUser.email);
  const [formData, setFormData] = useState({
    name: auth.currentUser.displayName,
    email: auth.currentUser.email,
  });

  const { t } = useTranslation();
  const userId = auth.currentUser.uid; 

  const onLogout = () => {
    auth.signOut();
    navigate("/");
  };

  useEffect(() => {
    // refreshList();
  }, []); // Empty dependency array means this effect will run once on mount
 
  return (
    <> 
      <div className="max-w-6xl px-3 mt-6 mx-auto"> 
          <>
            <h2 className="text-2xl text-center font-semibold mb-6">
              {t('my_annonce')}
            </h2>
             <AdsList uid={userId}/>
           </> 
      </div>
    </>
  );
}

export default MyAds;
